import React, { useEffect, useRef, useState } from "react";
import i18n from "i18next";
import _ from "lodash";

import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import styles from "./customModalDialog.module.scss";
import Button from "../buttons/Buttons";
import PropTypes from "prop-types";

function BootstrapDialogTitle(props) {
  const { isCloseButton, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {isCloseButton ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
function CustomModalDialog(props) {
  const {
    isShow,
    title,
    onClose,
    children,
    className,
    isCloseButton,
    doScrollToTop,
    isShowHeader = true,
    hasFooter = true,
    cancelBtnLabel = "",
    primaryButnFn,
    primaryBtnLabel = "",
  } = props;
  const [show, setShow] = useState(false);
  const scrollRef = useRef(null);

  if (doScrollToTop) {
    const scrollToElement = () => scrollRef?.current?.scrollIntoView();
    scrollToElement();
  }
  const handleClose = () => {
    setShow(false);
    onClose(false);
  };

  useEffect(() => {
    setShow(isShow);
  }, [isShow]);
  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));
  
  return (
    <div data-testid="custom-modal-test" className={styles.customModal}>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={show}
        dialogClassName={_.isEmpty(className) ? "customModalDialog" : className}
        id={_.isEmpty(className) ? "customModalDialog" : className}
      >
        {isShowHeader ? (
          <BootstrapDialogTitle
            ref={scrollRef}
            id="customized-dialog-title"
            onClose={handleClose}
            isCloseButton={isCloseButton}
          >
            <span className="modal-title"> {i18n.t(title)} </span>
          </BootstrapDialogTitle>
        ) : (
          ""
        )}
        <DialogContent dividers>
          {children}

          {hasFooter ? (
            <Box className={"buttonWrapper"}>
              <Button
                title={cancelBtnLabel}
                iconStyle={""}
                buttonType="muibtn-secondary"
                withIcon={false}
                handleClick={handleClose}
              />
              <Button
                title={primaryBtnLabel}
                iconStyle={""}
                buttonType="muibtn-primary"
                withIcon={false}
                handleClick={primaryButnFn}
              />
            </Box>
          ) : null}
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}

export default CustomModalDialog;

CustomModalDialog.propTypes = {
  isShow: PropTypes.any,
  title: PropTypes.any,
  onClose: PropTypes.any,
  children: PropTypes.any,
  className: PropTypes.any,
  isCloseButton: PropTypes.any,
  doScrollToTop: PropTypes.any,
  isShowHeader: PropTypes.any,
  hasFooter: PropTypes.any,
  cancelBtnLabel: PropTypes.any,
  primaryButnFn: PropTypes.any,
  primaryBtnLabel: PropTypes.any,
};
BootstrapDialogTitle.propTypes ={
  isCloseButton: PropTypes.any, 
  children: PropTypes.any, 
  onClose: PropTypes.any
}